import React, { useRef } from "react";
import Icon from "components/Elements/Icon/Icon.tsx";
import { useUploader } from "contexts/uploaderContext/uploaderContext.js";
import { useUploaderInput } from "../Helpers/useUploaderInput.js";
import UploadProgressComponent from "../Reusable/UploadProgressComponent.js";
import RemoveAllFilesComponent from "../Reusable/RemoveAllFilesComponent.js";
import GoBackComponent from "../Reusable/GoBackComponent.js";
import FilesCounterTitle from "../Reusable/FilesCounterTitle.js";

const InputFileElement = () => {
  const filesRef = useRef();
  const folderRef = useRef();

  const { handleAddFiles } = useUploaderInput({
    filesRef,
    folderRef,
  });
  return (
    <div className="upload-area-ui">
      <Icon name={"home/add_files_white"} onClick={handleAddFiles} />
      <div className="hidden-inputs">
        <input type="file" className="files-input" ref={filesRef} multiple />
        <input
          type="file"
          className="folders-input"
          aria-hidden="true"
          webkitdirectory=""
          directory=""
          multiple
          ref={folderRef}
        ></input>
      </div>
    </div>
  );
};

export const MobileUploaderHeader = ({ listView, setListView }) => {
  const { uploaderGetFiles, getUploading } = useUploader();

  const filesExist = uploaderGetFiles().length > 0;

  return (
    <>
      <div className="mobile-uploader-header">
        {getUploading() ? (
          <UploadProgressComponent />
        ) : (
          <>
            <GoBackComponent />
            {filesExist ? <InputFileElement /> : null}
          </>
        )}
      </div>
      {filesExist ? (
        <div className="preview-gallery-header">
          <FilesCounterTitle />
          <RemoveAllFilesComponent />
          <div className="view-grid-ui">
            <div
              className="view-icon-wrapper"
              onClick={() => {
                setListView((prev) => !prev);
              }}
            >
              <Icon
                name={
                  listView ? "home/thumbreview_icon" : "home/listpreview_icon"
                }
              />
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};
